import { RatingCategory } from '@sona/shared-model-common';

import { IRatingRange } from './rating-range.interface';

/**
 * An ordered list which contains all {@link RatingCategory category ratings} with their assigned information
 */
export const ORDERED_RATINGS = [
    { lowerBoundary: 0.9, category: RatingCategory.GOOD },
    { lowerBoundary: 0.6, category: RatingCategory.SUFFICIENT },
    { lowerBoundary: 0, category: RatingCategory.FAILED }
]
    .sort((a, b) => b.lowerBoundary - a.lowerBoundary)
    .map((v, i, a) => ({
        ...v,
        upperBoundary: i === 0 ? 1 : a[i - 1].lowerBoundary
    })) as IRatingRange<RatingCategory.GOOD | RatingCategory.SUFFICIENT | RatingCategory.FAILED>[];

export const RATING_MAP = ORDERED_RATINGS.reduce(
    (acc, cur) => {
        acc[cur.category] = cur;
        return acc;
    },
    {} as Record<RatingCategory, IRatingRange>
);
